import React from 'react';
import PropTypes from 'prop-types';
import Header from '../../../../components/Header';

export default function PreviewPaper({ onBack }) {
  return (
    <div style={{ marginTop: 20 }}>
      <Header title="Preview Test" onBack={onBack} />
    </div>
  );
}

PreviewPaper.propTypes = {
  onBack: PropTypes.func
};
